<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <div>
            <div class="m-portlet m-b-10">
                <div class="m-portlet__body">
                    <el-form>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="选择学期">
                                    <el-select v-model="semesterType_id"  placeholder="请选择学期" filterable remote
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in semesterTypes"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="m-portlet m-b-0">
                <div class="m-portlet__body" v-loading="loading">
                    <el-table
                            :data="sectionStudents"
                            :span-method="objectSpanMethod"
                            border
                            :height="clientHeight-300"
                            style="width: 100%"
                            size="middle">
                        <el-table-column prop="section_name" label="校区" align="center"></el-table-column>
                        <el-table-column prop="grade_name" label="年级" align="center"></el-table-column>
                        <el-table-column prop="all" label="总人数" align="center"></el-table-column>
                        <el-table-column prop="avg_period" label="平均课次" align="center"></el-table-column>
                        <el-table-column prop="normal" label="正常" align="center"></el-table-column>
                        <el-table-column prop="cancel" label="取消" align="center"></el-table-column>
                        <el-table-column prop="trying" label="试听" align="center"></el-table-column>
                        <el-table-column prop="cart" label="购物车" align="center"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                path:"/renewalSemesterStudent/list",
                semesterTypes:[],
                showDecimal:false,
                sectionStudents:[],
                semesterType_id:'',
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            };
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.semester_id=this.$store.state.config.nowSemester.id;
            this.handleCreate();
            this.handleIndex();
            this.handleShow();
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.semesterTypes =data.semesterTypes;
                        break;
                    case 'list':
                        this.sectionStudents=data.sectionStudents;
                        this.semesterType_id=data.semesterType_id
                        this.loading = false;
                        break;
                }
            },
            handleChange(){
                this.loading = true;
                this.handleIndex();
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'semesterType_id': this.semesterType_id,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    return {
                        rowspan: row.rowspan,
                        colspan: row.colspan
                    };

                }
            },
        }
    }
</script>


<style scoped>

</style>
